import React, { useEffect, useState, useContext } from "react";
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout";
import { GridLayout } from "../components/layout";
import { Spinner } from "../atoms/spinner";
import { StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { CourseComp } from "../components/courseComp";
import { fetchAPI } from "../api/api";
import { PageContext, UserContext } from "../App";

export function SearchP({searchTerm, oldPage, goToStep}) {
    const navigationContext = useContext(PageContext);
    const [isSearching, setSearchState] = useState(true);
    const [userResults, setUserResults] = useState([]);
    const [courseResults, setCourseResults] = useState([]);
    useEffect(() => {
        setSearchState(true)
        const delayDebounceFn = setTimeout(() => {
            searchQuery();
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    async function searchQuery() {
        var courses_search = await fetchAPI("api/courses/search?query=" + searchTerm)
        var users_search = await fetchAPI("api/users/search?query=" + searchTerm)

        setCourseResults(courses_search)
        setUserResults(users_search)

        setSearchState(false)
    }

    return (
        <VerticalPageLayout className="standard-padding" style={{"boxSizing": "border-box"}}>
            <HorizontalLayout className="phone-search-btn" style={{"gap": "1rem"}}>
                <StandardButton onClick={() => {goToStep(oldPage)}} title={icon("arrow-left")}></StandardButton>
                <h3 className="search-title">Zoekresultaten voor <i>{searchTerm}</i></h3>
            </HorizontalLayout>
            { isSearching ? <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", "height": "100%"}}>
                <Spinner/>
                <p className="standard-margin-top standard-text-color-light">Even geduld, bezig met zoeken...</p>
            </div> : <SearchResultsGrid oldPage={oldPage} userResults={userResults} courseResults={courseResults}/> }
        </VerticalPageLayout>
    );
}

function SearchResultsGrid({userResults, courseResults, oldPage}) {
    return (
        <div>
            { oldPage === 3 ? <><UserResultsGrid userResults={userResults}/><br/><CourseResultsGrid courseResults={courseResults}/></> : <><CourseResultsGrid courseResults={courseResults}/><br/><UserResultsGrid userResults={userResults}/></> }
        </div>
    );
}

function CourseResultsGrid({courseResults}) {
    var navigationContext = useContext(PageContext)
    const [showAllCourses, setShowAllCourses] = useState(false);
    const displayedCourses = showAllCourses ? courseResults : courseResults.slice(0, 4);

    function getCourseStatus(course) {
        if (course.published === 1) {
            return "gepubliceerd";
        } else if (course.progress < 100) {
            return "bezig";
        } else if (course.progress === 100) {
            return "afgerond";
        }
        return "notPublished";
    }  
   
    return (
        <>
        <HorizontalLayout className="space-between">
        <h5 className={"standard-small-margin-bottom search-result-title"}>Cursussen ({ courseResults.length } resultaten)</h5>
            { courseResults.length > 4 &&
                <div style={{marginBottom: "1rem", textAlign: "center"}}>
                    <StandardButton onClick={() => setShowAllCourses(!showAllCourses)} title={showAllCourses ? "Toon minder" : "Toon alles"} />
                </div>
            }
        </HorizontalLayout>
            { courseResults.length > 0 ? <>
                <GridLayout className="search-result-grid" style={{ gridAutoRows: "240px" }} columnsTemplate="1fr 1fr 1fr 1fr" gap="16px">
                    {displayedCourses.map((course, index) => {
                        const imageUrl = course.image_url || `https://ui-avatars.com/api/?name=${course.title}`;
                        console.log("course", course);
                        return (
                            <CourseComp
                                status={getCourseStatus(course)}
                                onClick={() =>
                                    navigationContext.handleNavigation({
                                        navigation: course.published ? 7 : 5,
                                        courseID: course.id_course,
                                        enrollment: 0,
                                    })
                                }
                                key={index}
                                title={course.title}
                                duration={course.duration}
                                lessons={course.lessons}
                                image={imageUrl}
                            />
                        );
                    })}
                </GridLayout>
            </> : <>
                <div style={{"background-color": "var(--card-background-color)", "padding": "1.5rem", "borderRadius": "1rem", "borderStyle": "solid", "borderColor": "var(--border-color)", "borderWidth": "1px", "width": "calc(100% - 2rem)", "marginTop": "0.6rem", "textAlign": "center"}}>
                    <span style={{"color": "var(--standard-text-color-light)"}}>{ icon("book-off", 96) }</span>
                    <p style={{"color": "var(--standard-text-color)"}}>Geen cursussen gevonden</p>
                </div>
            </> }
        </>
    );
}    

function UserResultsGrid({ userResults }) {
    const navigationContext = useContext(PageContext);
    const [showAllUsers, setShowAllUsers] = useState(false);
    const displayedUsers = showAllUsers ? userResults : userResults.slice(0, 6);
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1

    return (
        <>
            <HorizontalLayout className="space-between">
                <h5 className={"standard-small-margin-bottom search-result-title"}>
                    {isPublic ? "Leads" : "Werknemers"} ({userResults.length} resultaten)
                </h5>
                {userResults.length > 6 &&
                    <div style={{ marginBottom: "1rem", textAlign: "center" }}>
                        <StandardButton
                            onClick={() => setShowAllUsers(!showAllUsers)}
                            title={showAllUsers ? "Toon minder" : "Toon alles"}
                        />
                    </div>
                }
            </HorizontalLayout>

            {userResults.length > 0 ? (
                <GridLayout
                    className="search-user-result-grid"
                    style={{ gridAutoRows: "120px" }}
                    columnsTemplate="1fr 1fr 1fr 1fr 1fr 1fr"
                    gap="16px"
                >
                    {displayedUsers.map((user, index) => (
                        <VerticalLayout className="profile-item" key={index} style={{ alignItems: "center" }}>
                            <StandardButton
                                className={"search-result-btn"}
                                onClick={() =>
                                    navigationContext.handleNavigation({
                                        navigation: 6,
                                        userId: user.id_users,
                                    })
                                }
                            >
                                <img className="rounded-img" style={{ height: "4rem", width: "4rem", margin: "0px 0px 0.5rem 0px" }} src={`https://ui-avatars.com/api/?name=${user.full_name}&background=random&color=fff&format=svg`} />
                                <p className="small-text-dark">{user.full_name}</p>
                            </StandardButton>
                        </VerticalLayout>
                    ))}
                </GridLayout>
            ) : (
                <div style={{ backgroundColor: "var(--card-background-color)", padding: "1.5rem", borderRadius: "1rem", borderStyle: "solid", borderColor: "var(--border-color)", borderWidth: "1px", width: "calc(100% - 2rem)", marginTop: "0.6rem", textAlign: "center", }}>
                    <span style={{ color: "var(--standard-text-color-light)" }}>
                        {icon("x", 96)}
                    </span>
                    <p style={{ color: "var(--standard-text-color)" }}>Geen werknemers gevonden</p>
                </div>
            )}
        </>
    );
}